export const apiEndPoints = {
    city: 'country-with-city',
    login: 'login',
    notification: 'notification',
    verify: 'verify',
    reset_password: 'reset-password',
    register: 'register',
    objStudyReport: `obj-study-report`,
    userInfo: `user`,
    reports: `reports`,
    totalInventoryReport: 'total-inventory-report',
    filterDataList: 'filter-data-list',
    casecaddingfilter: 'cascading-filter-data',
    combineFilterDataList: 'combine-filter-data-list',
    userReports: `user-reports`,
    userBuckets: `user-buckets`,
    investmentUnitReport: 'investment-unit-report',
    unitTypeReport: 'unit-type-report',
    propertyReport: 'property-report',
    unitGradeReport: 'unit-grade-report',
    recentSavedReport: 'recent-saved-report',
    profileImage: `profile-image`,
    unitTypeOccupancyLeaseReport: 'unit-type-occupancy-lease-report',
    populationAgeWiseReport: 'population-age-wise-report',
    populationTotalReport: 'population-total-report',
    userActivity: `user-activity`,
    userPreference: 'user-preference',
    language: 'language',
    userNotifications: 'user-notification-preference',
    userSetting: 'user-setting',
    underConstructionTotalReport: 'under-construction-total-report',
    underConstructionNeighPropertyReport: 'under-construction-neigh-property-report',
    mallProfilingTotalReport: 'mall-profiling-total-report',
    mallProfilingFloorWiseReport: 'mall-profiling-floor-wise-report',
    mallInventoryTotalReport: 'mall-inventory-total-report',
    mallInventoryNeighTrendlReport: 'mall-inventory-neigh-trend-report',
    retailfnbAverageLeaseCategoryReport: 'retail-fnb-average-lease-category-report',
    retailfnbTrendAreaTentantReport: 'retail-fnb-trend-area-occupied-tenant-report',
    retailfnbTotalReport: 'retail-fnb-total-report',
    mallTenantLeaseRatePropertyTypeReport: 'mall-tenant-lease-rate-property-type-report',
    mallTenantTrentAreaReport: 'mall-tenant-trend-area-report',
    mallTenantTotalReport: 'mall-tenant-total-report',
    userSubscription: `user-subscription`,
    subscriptionRequest: `subscription-request`,
    investmentPropertyReport: 'investment-property-report',
    unitOccupancyLeaseReport: 'unit-occupancy-lease-report',
    unitOccupancyTypeReport: 'unit-occupancy-type-report',
    populationYearWiseReport: 'population-year-wise-report',
    populationTrendlineReport: 'population-trendline-report',
    yearwiseOccupancyLeaseReport: 'year-wise-occupancy-lease-report',
    retailFnbCuisineWiseSplitAreaReport: 'retail-fnb-cuisine-wise-split-area-report',
    retailFnbCategoryWiseReport: 'retail-fnb-category-wise-report',
    mallTenantShareCategoryReport: 'mall-tenant-share-category-report',
    mallInventoryYearlyUnitsReport: 'mall-inventory-yearly-units-report',
    mallInventoryYearlyOccupancyReport: 'mall-inventory-yearly-occupancy-report',
    mallInventoryYearlyIncrementalReport: 'mall-inventory-yearly-incremental-report',
    propertyProfilingTotalReport: 'property-profiling-total-report',
    typeGradePropertyProfilingReport: 'type-grade-property-profiling-report',
    typePropertyProfilingReport: 'type-property-profiling-report',
    gradeFurnishedPropertyProfilingReport: 'grade-furnished-property-profiling-report',
    amenitiesPropertyProfilingReport: 'amenities-property-profiling-report',
    changePassword: 'change-password',
    contactUs: 'contact-us',
    requestAccount: 'request-account',
    transactionSummary: 'transaction-summary',
    unitTransactionSummary: 'unit-transaction-summary',
    propertyTransactionSummary: 'property-transaction-summary',
    propertyTransaction: 'property-transaction',
    propertyTransactionHistory: 'property-transaction-datewise-report',
    unitTransactionHistory: 'unit-transaction-datewise-report',
    unitTransaction: 'unit-transaction',
    downloadTransactionReport: 'download-transaction-report',
    downloadExcel: 'download-report',
    bulkUpdateReport: 'bulk-update-report',
    bulkDeleteReport: 'bulk-delete-report',
    propertyTransactionDetail: 'property-transaction-detail',
    houseVillaLandInformation: 'house-villa-land-information',
    houseVillaAreaInformation: 'house-villa-area-information',
    houseVillasSummary: 'house-villa-overview-details-report',
    houseVillaGraph: 'house-villa-graph-details-report',
    projectHouseVillas: 'house-villa-project-villa-list',
    independentHouseVillas: 'house-villa-independent-villa-list',
    governorHouseVillas: 'house-villa-govt-list',
    houseVillaPropertyDetail: 'house-villa-property-detail',
    // houseVillaProjectDetail: 'house-villa-project-details',
    downloadHouseVillaReport: 'download-house-villa-report',
    neighDetails: 'neigh-details',
    reportDownload: 'report-download',
    saveFilter: 'save-filter',
    getSavedFilter: 'saved-filter',
    dashboardMapTransaction : 'top-transactions',
    reportMapCluster: 'map-property-cluster-details',
    logout: 'logout',
    houseLandVacancyOverview: 'house-villa-land-vacancy-overview-report',
    houseLandVacancyList: 'house-villa-land-vacancy-list-report',
    houseRentalOverview: 'house-villa-rental-overview-report',
    houseRentalList: 'house-villa-rental-list-report',
    searchMaster: 'search-master',
    userReportCount: 'user-report-count',
    officeRentalpropertyListReport: 'office-rental-property-list-report',
    officeRentalRentUnitSizewiseReport: 'office-rental-rent-unit-sizewise-report',
    officeRentalOverviewReport: "office-rental-overview-report",
    officeRentalOverviewSubCategoryDetailsReport: "office-rental-overview-sub-category-details-report",
    officeRentalRentRateOverviewGraphdataReport: "office-rental-rent-rate-overview-graphdata-report",
    retailRentalUnit: 'retail-rental-unit-report',
    retailRentalUnitSize: 'retail-rental-rent-unitsize-report',
    retailRentalOverview: 'retail-rental-overview-report',
    retailRentalRentrate: 'retail-rental-rentrate-report',
    retailRentalOverviewSubCategory: 'retail-rental-overview-sub-category-details-report',
    retailRentalRentrateReport: 'retail-rental-rentrate-report',
    warehouseOverviewReport: 'warehouse-overview-report',
    warehouseRentrateReport: 'warehouse-rentrate-report',
    // warehouseUnitReport: 'warehouse-unit-report',
    warehousePropertiesReport: 'warehouse-properties-report',
    warehouseRentunitsizeReport: 'warehouse-rent-unitsize-report',
    retailWarehouseOverviewSubCategory: 'warehouse-overview-sub-category-details-report',
    houseVillaProjectUnitDetails: 'house-villa-project-unit-details',
    houseVillaProjectAreaOverview: 'house-villa-project-area-overview',
    houseVillaProjectLandInfo: 'house-villa-project-land-info',
    inventoryOverviewReport: 'ir-inventory-overview-report',
    inventoryPropertyGraphReport: 'ir-inventory-property-graph-report',
    inventoryNeighWisePropertiesReport: 'ir-inventory-neighwise-properties-report',
    inventoryProjectsAndPropertiesReport: 'ir-inventory-projects-and-properties-report',
    inventoryUnitReport: 'ir-inventory-unit-report',
    inventoryUnitTransctionReport: 'ir-inventory-unit-transactions-report',
    inventoryOverviewPropertyReport: 'ir-inventory-property-overview-report',
    inventoryAreaPropertyReport: 'ir-inventory-property-area-overview-report',
    inventoryProjectReport: 'ir-inventory-project-report',
    inventoryOverviewProjectReport: 'ir-inventory-project-overview-report',
    inventoryUnitProjectReport: 'ir-inventory-project-unit-report',
    inventoryUnitTransactionProjectReport: 'ir-inventory-project-unit-transactions-report',
    inventoryProjectpropertiesReport: 'ir-inventory-project-properties-report',
    inventoryAreaProjectReport: 'house-villa-project-area-overview',
    occupancyResidentialUnitsGradewiseReport: 'ir-occupancy-residential-units-gradewise-report',
    occupancyResidentialUnitstypewiseReport: 'ir-occupancy-residential-units-typewise-report',
    occupancyCommercialUnitsGradewiseReport: 'ir-occupancy-commercial-units-gradewise-report',
    occupancyCommercialUnitsSizewiseReport: 'ir-occupancy-commercial-units-sizewise-report',
    occupancyUnitRentalTransactionsReport: 'ir-occupancy-unit-rental-transactions-report',
    // occupancyPropertyOverviewReport: 'ir-occupancy-property-overview-report',
    occupancyPropertyUnitReport: 'ir-occupancy-property-unit-report',
    occupancyPropertyUnitTransactionsReport: "ir-occupancy-property-unit-transactions-report",
    PropertyAmenities: 'property-details-amenities',
    reportPropertyDetailsOverview: 'property-details-overview',
    reportPropertyDetailsBuiltupinfo: 'property-details-builtup-info',
    reportPropertyDetailsPropertytransactions: 'property-details-property-transactions',
    // propertyDetailsTransactionsHistoryReportV2: 'property-details-transactions-history-report-v2',
    reportPropertyDetailsCostofconstruction: 'property-details-cost-of-construction',
    reportPropertyDetailsresidentialrentalincomesubtypewise: 'property-details-residential-rental-income-subtypewise',
    reportPropertyDetailsresidentialrentalincometypewise: 'property-details-residential-rental-income-typewise',
    reportPropertyDetailsPropertyInfo: 'property-details-property-info',
    reportPropertyDetailsMaxPermittedFloor: 'property-details-max-permitted-floors',
    reportPropertyDetailsLandValue: 'property-details-land-value-transactions-count',
    userSettings:'user-settings',
    retailInventoryOverview: 'retail-inventory-overview-report',
    retailInventoryOverviewV2: 'retail-inventory-overview-report-v2',
    retailInventoryPropertyCount: 'retail-inventory-property-count-typewise',
    retailInventoryglaCount: 'retail-inventory-deveoplers-gla-count-report-v2',
    retailInventoryGlaShare: 'retail-inventory-gla-share-typewise',
    retailInventoryGlaShareV2: 'retail-inventory-construction-wise-gla-count-report-v2',
    retailInventoryProperties: 'retail-inventory-properties',
    retailInventoryPropertiesV2: 'retail-inventory-properties-report-v2',
    retailInventoryTenants: 'retail-inventory-tenants',
    retailInventoryUnits: 'retail-inventory-units',
    retailInventoryTrends: 'retail-inventory-trends',
    retailInventoryrentratereportv2: 'retail-inventory-rent-rate-report-v2',
    retailInventoryNeighborhoodInsights: 'retail-inventory-neighborhood-insights',
    retailInventoryNeighborhoodInsightsV2: 'retail-inventory-neighborhood-insights-v2',
    retailInventoryDepartments: 'retail-inventory-departments',
    warehouseInventoryOverview: 'warehouse-inventory-overview-report',
    warehouseInventoryOverviewSubCat: 'warehouse-inventory-overview-subcat-report',
    warehouseInventoryGrossBuiltupReport: 'warehouse-inventory-gross-builtup-report',
    warehouseInventoryNeighborhood: 'warehouse-inventory-neighborhood_report',
    warehouseInventoryProperties: 'warehouse-inventory-property-report',
    officeInventoryOverviewReport: 'office-inventory-overview-report',
    warehouseInventoryGrossLandCoverageReport: 'warehouse-inventory-gross-land-coverage-report',
    officeInventoryGrossReport: 'office-inventory-gross-report',
    officeInventoryNeighborhoodReport: 'office-inventory-neighborhood-report',
    officeInventoryPropertiesReport: 'office-inventory-properties-report',
    retailInventoryTenantFloorDetail: 'retail-inventory-tenant-floor-detail',
    retailInventoryTenantDetails: 'retail-inventory-tenant-map-detail',
    powerBiEmbedToken: 'embed-token',
    geoJsonParcelLayer: 'parcel-layer',
    // geoJsonParcelLayerClickHouse: 'ch-parcel-layer',
    geoJsonParcelLayerClickHouse: 'ch-parcel-layer-legend',
    geoJsonPbfParcelLayerClickHouse: 'ch-parcel-layer-map',
    mapDetailsPopup: 'map-details-pop-up',
    amenitiesFilter: 'amenities-filter',
    propertySearch : 'property-search',
    catchmentproperties: 'catchment-properties',
    recentSearchedProperties : 'recent-searched-properties',
    recentSearchedPropertiesDelete : 'recent-searched-properties',
    biPropertyDetails:'bi-property-details',
    retailRentalRentMallwiseReport: 'retail-rental-rent-mallwise-report',
    propertyDetailsUnitRentalReport : 'property-details-unit-rental-report',
    streetNameFilter: 'street-filter',
    userResource : 'user/resource',
    warehouseRentalOverviewReportV2: "warehouse-rental-overview-report-v2",
    warehouseRentalOverviewNeighwiseReportV2: "warehouse-rental-overview-neighwise-report-v2",
    officeRentalOverviewReportv2: "office-rental-overview-report-v2",
    officeRentalOverviewNeighwiseReportv2: "office-rental-overview-neighwise-report-v2",
    officeRentalRentRateReportv2 : "office-rental-rent-rate-report-v2",
    officeRentalRentUnitsizeReportv2: 'office-rental-rent-unitsize-report-v2',
    officeRentalPropertiesReportv2: 'office-rental-properties-report-v2',
    officeRentalTransactionVolumeReportv2: 'office-rental-transaction-volume-report-v2',
    warehouseRentalRentrateReportV2: "warehouse-rental-rentrate-report-v2",
    warehouseRentalRentUnitsizeReportV2: "warehouse-rental-rent-unitsize-report-v2",
    warehouseRentalPropertiesReportV2: "warehouse-rental-properties-report-v2",
    warehouseRentalProjectReportV2: "warehouse-rental-project-report-v2",
    warehouseRentalPropertyReportV2: "warehouse-rental-property-report-v2",
    retailRentalOverviewV2 : "retail-rental-overview-report-v2",
    retailRentalOverviewOccupancyV2 : "retail-rental-overview-occupancy-report-v2",
    retailRentalRentrateReportV2 : "retail-rental-rentrate-report-v2",
    retailRentalUnitV2: "retail-rental-unit-report-v2",
    retailRentalUnitSizeV2 : "retail-rental-rent-unitsize-report-v2",
    retailRentalRentMallwiseReportV2: "retail-rental-rent-mallwise-report-v2",
    projectDetailsOverview: "project-details-overview",
    projectDetailsLandParcel: "project-details-land-parcel",
    projectDetailsPropertyHouses: "project-details-property-houses",
    projectDetailsPropertyOthers: "project-details-property-others",
    officeInventoryOverviewReportV2: "office-inventory-overview-report-v2",
    officeInventoryGrossReportV2: "office-inventory-gross-report-v2",
    officeInventoryYearwiseSupplyReportV2: "office-inventory-yearwise-supply-report-v2",
    officeInventoryNeighborhoodReportV2: "office-inventory-neighborhood-report-v2",
    propertyDetailPdfDownload: "pdf-download-property-detail",
    reportDownloadChartPdf: "report-download-chart-pdf",
    pdfDownloadOption: "pdf-download-option",
    occupancyOverviewReportV2: "ir-occupancy-overview-report-v2",
    occupancyOverviewSubCategoryDetailsReportV2: "ir-occupancy-overview-sub-category-details-report-v2",
    irOccupancyRentalRentrateReportV2: "ir-occupancy-rental-rentrate-report-v2",
    irOccupancyRentalGradeWiseReportV2: "ir-occupancy-rental-grade-wise-report-v2",
    irOccupancyRentalTypeWiseReportV2: "ir-occupancy-rental-type-wise-report-v2",
    irOccupancyRentalPropertyTransactionReportV2: "ir-occupancy-rental-property-transaction-report-v2",
    irOccupancyRentalCommercialGradeWiseReportV2: "ir-occupancy-rental-commercial-grade-wise-report-v2",
    irOccupancyRentalCommercialSizeWiseReportV2: "ir-occupancy-rental-commercial-size-wise-report-v2",
    propertyDetailOfficeUnitRental: "property-detail-office-unit-rental",
    propertyDetailRetailUnitRental : "property-detail-retail-unit-rental",
    propertyDetailRetailUnitSize : "property-detail-retail-unit-size",
    propertyDetailOfficeUnitSize : "property-detail-office-unit-size",
    residentialNearbyRentalsOccupancy : "property-details-residential-nearby-rentals-occupancy",
    propertyDetailWarehouseUnitSize:"property-detail-warehouse-unit-size",
    warehouseInventoryOverviewReportv2 :"warehouse-inventory-overview-report-v2",
    warehouseInventoryLandPriceReportv2 :"warehouse-inventory-land-price-transactions-report-v2",
    warehouseInventoryPropertyTransactionReportv2 :"warehouse-inventory-building-price-transactions-report-v2",
    warehouseInventoryOverviewGraphv2 :"warehouse-inventory-overview-graph-report-v2",
    warehouseRentalOverviewRentalYieldReportV2 :"warehouse-inventory-rental-yeild-report-v2",
    ProjectDetailsResidentialRental:"project-details-residential-rental",
    ProjectDetailsRetailRental:"project-details-retail-rental",
    ProjectDetailsOfficeRental:"project-details-office-rental",
    ProjectDetailsWarehouseRental:"project-details-warehouse-rental",
    ProjectDetailsResidentialAnalysis:"project-details-residential-analysis",
    ProjectDetailsretailAnalysis:"project-details-retail-analysis",
    ProjectDetailsOfficeanAlysis:"project-details-office-analysis",
    projectLandPricesDetails:"project-details-land-price-report",
    projectPropertyPriceDetails:"project-details-property-price-report",
    projectUnitPriceDetails:"project-details-unit-price-report",
    projectDetailsLandPriceAnalysisReport:"project-details-land-price-analysis-report",
    projectDetailsHousePriceAnalysisReport:"project-details-house-price-analysis-report",
    projectDetailsApartmentPriceAnalysisReport:"project-details-apartment-price-analysis-report",
    projectDetailsResidentialBuildingPriceAnalysisReport:"project-details-residential-building-price-analysis-report",
    propertyDetailsRental:"property-details-rental",
    propertyDetailLandPriceAnalysis : "property-detail-land-price-analysis-project-neigh",
    propertyDetailVillaPriceAnalysis :"property-detail-villa-price-analysis-project-neigh",
    propertyDetailApartmentResidentialPriceAnalysis :"property-detail-apartment-residential-price-analysis",
    propertyDetailRetailRentalAnalysisPropertyProject :"property-detail-retail-rental-analysis-property-project",
    propertyDetailOfficeRentalAnalysisPropertyProject :"property-detail-office-rental-analysis-property-project",
    propertyDetailwarehouseRentalAnalysis: "property-detail-warehouse-rental-analysis",
    farUsage:"far-usage",
    setting:"setting",
 }
